import { render, staticRenderFns } from "./rejectAppeal.vue?vue&type=template&id=14c16ba1&scoped=true&"
import script from "./rejectAppeal.vue?vue&type=script&lang=js&"
export * from "./rejectAppeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c16ba1",
  null
  
)

export default component.exports